import { createElement } from 'react';
import { Drawer as OriginalDrawer } from 'antd';
import { BaseDialog } from '../../shared/base/BaseDialog';
export default class ProDrawer extends BaseDialog {
    render() {
        const innerProps = this.transformProps();
        return (createElement(OriginalDrawer, { ...this.props, ...innerProps, onClose: innerProps.onCancel }));
    }
}
